import styled from 'styled-components';

export const ModalContainer = styled.div`
  height: 100%;
  width: 100%;
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(125, 132, 148, 0.5);

  button {
    cursor: pointer;
  }
`;

export const ModalBox = styled.div`
  background-color: #ffffff;
  width: 50%;
  height: 80%;
  padding: 0 23px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.015em;
  text-align: left;
  border-bottom: 1px solid rgba(241, 241, 241, 1);
  height: 15%;

  div {
    text-transform: uppercase;

    span {
      text-transform: lowercase;
    }
  }

  img {
    cursor: pointer;
  }
`;

export const ModalMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 70%;
`;

export const ModalText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.015em;
  text-align: left;
`;

export const ModalOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  background-color: rgba(225, 225, 225, 1);
  cursor: pointer;
`;

export const ModalOptionText = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: -0.015em;
  margin: 0 10px;
  text-wrap: wrap;
`;

export const ModalOptionButton = styled.button`
  background: rgba(240, 240, 240, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  width: 50px;
  height: fit-content;
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`;

export const ModalCloseButton = styled.button`
  border: none;
  background: rgba(190, 214, 0, 1);
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
  width: 172px;
  height: 36px;
`;

export const ModalFooter = styled.form`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid rgba(241, 241, 241, 1);
  height: 15%;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: -0.015em;
  align-items: center;
  text-align: center;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ModalImage = styled.img`
  height: auto;
  max-height: 100%;
  width: 40%;
`;

export const ModalMainContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 60%;
  padding: 2% 0;
  height: 100%;
`;

export const ModalOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  align-items: left;
`;

export const ModalTextContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: left;
`;

export const OptionIcon = styled.img`
  padding: 10px 5px;
  background-color: rgba(240, 240, 240, 1);
`;
